/**
 * Created by hernanherreros on 2019-07-05
 */

import * as React from 'react'

export const mobileStoreLinks: any = {
  
  lowcost: {
    ios: 'https://apps.apple.com/cl/app/trazo-events/id1476474475',
    android: 'https://play.google.com/store/apps/details?id=com.trazolabs.summit.trazoevents'
  },
  enloce2020: {
    ios: 'https://apps.apple.com/cl/app/enloce-vii/id1478955692',
    android: 'https://play.google.com/store/apps/details?id=com.trazolabs.summit.enloce2019'
  },
}
